export default __webpack_public_path__ + "static/media/bike-purple.f468311e.svg";